export default "__VITE_PUBLIC_ASSET__1fc89946__"